import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Spin } from "antd";

export default function GlobalSpinner({ loading = true }) {
  return (
    <Spin
      size="large"
      spinning={loading}
      indicator={<Loading3QuartersOutlined spin className="!text-primary-tint"/>}
      fullscreen
      className="custom-spin"
    />
  );
}
